
    var riot = require('riot')
    //src: starling/src/tags/comments/comment-replies.html
riot.tag2('comment-replies',
  '<button class="Button Button--Secondary Button--Small Button--Link" onclick="{toggle}" style="--button-font-family: Roboto; --button-font-weight: normal;"> {getReplyLabel()} </button> <div if="{isOpen}" class="comment_replies"> <comment each="{getReplies()}" instance="{this}" canvas="{parent.canvas}" size="{parent.size}" type="{parent.type}"></comment> </div>',
  '',
  'class="comment_replies_container"', function(opts) {
'use strict';

var _this = this;

var _opts = opts,
    canvas = _opts.canvas,
    size = _opts.size,
    type = _opts.type;

Object.assign(this, { canvas: canvas, size: size, type: type });

this.toggle = function (event) {
  event.stopPropagation();
  event.target.blur();
  _this.isOpen ? _this.collapse() : _this.expand();
};

this.expand = function () {
  _this.isOpen = true;
  _this.update();
};

this.collapse = function () {
  _this.isOpen = false;
  _this.update();
};

this.getReplies = function () {
  return canvas.store.getReplyComments(_this.parent.instance.id);
};

this.getReplyLabel = function () {
  var count = _this.getReplies().length;
  var label = count > 1 ? 'replies' : 'reply';
  return _this.isOpen ? 'Hide ' + label : 'Show ' + count + ' ' + label;
};
});

    
  if (module.hot) {
    module.hot.accept()
    if (module.hot.data) {
      riot.reload('comment-replies')
    }
  }
  


//////////////////
// WEBPACK FOOTER
// ./starling/src/tags/comments/comment-replies.html
// module id = 791
// module chunks = 0